import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CostsIndex from './pages/CostsIndex';

const CostsRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<CostsIndex />} />
  </Routes>
);

export default CostsRoutes;
